<template>
  <div class="">
    <header class="subheader">
    <div class="header__text-box">
      <h1 class="heading-primary">
        <span class="heading-primary--main">About</span>
      </h1>
     
    </div>
  </header>

    <main>
      <AboutMe />
    </main>
  </div>
</template>
<script>
import AboutMe from '@/components/about/AboutMe'
export default {
  name: 'About',
  components: {
    AboutMe
  },

  metaInfo() {
    return {
      title: "About",
      titleTemplate: '%s | Aaron Fletcher',
      meta: [
       { charset: 'utf-8' },
       { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        {
          
          vmid: "description",
          name: "description",
          content:
            "About Aaron Fletcher"
        }
      ]
    }
  },

}
</script>